import { render, staticRenderFns } from "./AddForecastForm.vue?vue&type=template&id=5230af3d&"
import script from "./AddForecastForm.vue?vue&type=script&lang=js&"
export * from "./AddForecastForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports